module.exports = __webpack_public_path__ + "img/claim-bg.204875d3.svg";